export default "__VITE_ASSET__BhvRrM_C__"